const SECONDS_IN_DAY = 24 * 60 * 60;

export const secondsToDays = (secs: number): number => secs / SECONDS_IN_DAY;
export const daysToSeconds = (days: number): number => days * SECONDS_IN_DAY;
export const secondsToDaysFloor = (secs: number): number => Math.floor(secs / SECONDS_IN_DAY);
export const secondsToDaysCeil = (secs: number): number => Math.ceil(secs / SECONDS_IN_DAY);

/* Форматирует секунды в hh:mm:ss */
export const formatDuration = (seconds: number) => new Date(seconds * 1000).toISOString().slice(11, 19);

/* Возвращает время в миллисекундах до указанной даты */
export const getTimeToDate = (date: Date) => date.getTime() - Date.now();
